import React from 'react';
import { LazyNotifications as Notifications } from './lazy-badge/index.tsx';

export const Badge = ({ releaseNotesNotifications = 0 }: { releaseNotesNotifications: number }) => {
	return releaseNotesNotifications > 0 && !__SERVER__ ? (
		<Notifications max={3} appearance="primary">
			{releaseNotesNotifications}
		</Notifications>
	) : null;
};
